module.exports = __webpack_public_path__ + "media/images/emblems/Daettlikon-blazon-3d2966cd9531bc8ef56bf5dfa9abf315.svg";